import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import _, { debounce } from "lodash";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import SelectAutoComplete from "../../components/SelectAutoComplete";
import { mapActionsToProps as diaplanAction } from "../../redux/cloudPBX/dialplan";
import { mapActionsToProps as ivrAction } from "../../redux/cloudPBX/ivr";
import { mapActionsToProps } from "../../redux/cloudPBX/phoneNumber";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
    overflow: "unset",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showPassword: false,
      modalAction: false,
      option: "ivr",
      listOption: [],
      selectedOption: "",
      widthOfAutoComplete: null,
    };
  }

  async componentDidMount() {
    this.props.getListIvr("createdAt DESC", null, null, null, { query: "all" });
    this.props.getListDialplan("createdAt DESC", null, null, null, {
      query: "all",
    });
    await this.itemInit();
    this.history = globalHistory();
    window.addEventListener("click", this.changeWidthModal);
  }

  changeWidthModal = () => {
    const checkActiveElement =
      document.activeElement.getAttribute("name") === "option";
    this.setState({ widthOfAutoComplete: checkActiveElement ? "210px" : null });
  };

  componentWillUnmount() {
    window.removeEventListener("click", this.changeWidthModal);
  }

  listCollumns = [
    { id: "id", numeric: true, disablePadding: false, label: "Đầu số" },
    { id: "type", numeric: true, disablePadding: false, label: "Loại" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Ngày tạo",
    },
    {
      id: "setDefault",
      numeric: true,
      disablePadding: false,
      label: "Đặt mặc định",
    },
    {
      id: "actionPhoneNumber",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "id":
            case "type":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListPhoneNumber(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.getNumberDefault(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.countNumber({ where });
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleView = (item) => {
    this.state.item = item;
    this.setState({ modalView: !this.state.modalView });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({
      modalAction: true,
      option: item.extenType ? item.extenType : "",
      selectedOption: item.extenId ? item.extenId : "",
      listOption:
        item.extenType === "ivr" ? this.props.ivrs : this.props.dialplans,
    });
  };

  handleCloseModel = () => {
    this.setState({ modalView: false });
  };

  handleSetDefault = (item) => {
    this.props.setDefaultNumber(item.id);
    this.itemInit();
  };

  handleClose = () => {
    this.setState({ modalAction: false });
  };

  handleChangeCheckBox = (e) => {
    this.setState({
      option: e.target.value,
      listOption:
        e.target.value === "ivr" ? this.props.ivrs : this.props.dialplans,
      selectedOption: "",
    });
  };

  filterOptions = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.title &&
              item.title.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  handleSearchOption = (text) => {
    const { option } = this.state;
    this.setState({
      listOption: this.filterOptions(
        _.values(option === "ivr" ? this.props.ivrs : this.props.dialplans),
        text
      ),
    });
  };

  handleAction = () => {
    const { item } = this.state;
    const data = {
      extenType: this.state.option,
      extenId: this.state.selectedOption,
    };
    this.props.editPhoneNumber(item.id, data);
    setTimeout(() => {
      this.itemInit();
      this.setState({ modalAction: false });
    }, 1000);
  };

  render() {
    const { classes, listPhoneNumber, count, result, results, item } =
      this.props;
    const { filters } = this.state;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listResult =
      typeof results === "object"
        ? Object.keys(results).map((key) => results[key])
        : results;
    const check = listPhoneNumberResult.find((item) =>
      listResult.length != 0 ? item.id == listResult[0].numberId : null
    );
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Đầu số"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.id}
                          name="id"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Loại"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.type}
                          name="type">
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          <MenuItem key="fixed-number" value="fixed-number">
                            Đầu số cố định
                          </MenuItem>
                          <MenuItem
                            key="free-toll-number"
                            value="free-toll-number">
                            Đang khóa
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách đầu số"
          items={listPhoneNumberResult}
          rowsPerPage={filters.pageSize}
          count={count ? count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleView={this.handleView}
          handleEdit={this.openModalEdit}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleSetDefault={this.handleSetDefault}
          checkbox={check}
        />
        <Dialog
          open={this.state.modalView}
          onClose={this.handleCloseModel}
          title="Chi tiết đầu số"
        />
        <Dialog
          open={this.state.modalAction}
          title={"Chỉnh sửa thông tin đầu số"}
          maxWidth={"sm"}
          fullWidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              {/*<FormControl className={classes.form}>*/}
              <Grid container className={classes.grid}>
                <Grid item md={12}>
                  <RadioGroup
                    aria-label="Chọn IVR/Dialplan"
                    className={classes.input}
                    value={this.state.option}
                    name="check-box"
                    onChange={(event) => this.handleChangeCheckBox(event)}>
                    <FormControlLabel
                      value={"ivr"}
                      control={
                        <Radio
                          classes={{
                            disabled: classes.disabled ? classes.disabled : "",
                          }}
                        />
                      }
                      label="IVR"
                      classes={{
                        disabled: classes.label ? classes.label : "",
                      }}
                    />
                    <FormControlLabel
                      value={"dialplan"}
                      control={
                        <Radio
                          classes={{
                            disabled: classes.disabled ? classes.disabled : "",
                          }}
                        />
                      }
                      label="Dialplan"
                      classes={{
                        disabled: classes.label ? classes.label : "",
                      }}
                    />
                  </RadioGroup>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{
                    marginTop: "6px",
                    height: this.state.widthOfAutoComplete
                      ? this.state.widthOfAutoComplete
                      : "auto",
                  }}>
                  <SelectAutoComplete
                    label={
                      this.state.option === "ivr"
                        ? "Tiêu đề Ivr"
                        : "Tiêu đề Dialplan"
                    }
                    data={
                      this.state.listOption && this.state.listOption.length > 0
                        ? this.state.listOption.map((val) => {
                            return {
                              id: val.id,
                              label: val.title
                                ? `${val.title} - ${val.id}`
                                : "",
                            };
                          })
                        : []
                    }
                    onSearch={debounce(
                      (text) => this.handleSearchOption(text),
                      0
                    )}
                    value={
                      this.state.selectedOption ? this.state.selectedOption : ""
                    }
                    onChange={(item) => {
                      this.setState({
                        selectedOption: item ? item.id : "",
                      });
                    }}
                    className={classes.input}
                    onClear={true}
                    name="option"
                  />
                </Grid>
              </Grid>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
              {/*</FormControl>*/}
            </ValidatorForm>
          }
          onClose={this.handleClose}
          overflow={"unset"}
        />
      </React.Fragment>
    );
  }
}

PhoneNumber.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  count: state.phoneNumber.count,
  result: state.phoneNumber.result,
  results: state.phoneNumber.results,
  ivrs: state.ivr.ivrs,
  dialplans: state.dialplan.dialplans,
});

const IvrAction = connect(null, ivrAction)(PhoneNumber);
const DiaplanAction = connect(null, diaplanAction)(IvrAction);
PhoneNumber = connect(mapStateToProps, mapActionsToProps)(DiaplanAction);

export default withStyles(styles)(PhoneNumber);
